<template>
  <span>
    <div class="main-block chat-page">
      <Breadcrumbs />
      <div class="div col-12 p-0 d-flex align-items-start">
        <h4 class="">{{ $t('title.rakoonChat') }}</h4>
      </div>
      <b-container fluid class="p-0 overflow-hidden d-flex">
        <RakoonChatHistory :selectedChat="selectedChat" @selectChat="setSelectedChat" ref="rakoonChatHistory"
          @createNewChat="newChat" />
        <RakoonChat :selectedChat="selectedChat" @getChatHistory="chatHistoryLists" ref="rakoonChat"
          @updateLatestChatHistory="latestChatHistory" />
      </b-container>
    </div>
  </span>
</template>
<script>
import RakoonChat from '@/components/RakoonChat.vue';
import RakoonChatHistory from '@/components/RakoonChatHistory.vue';
import Breadcrumbs from "@/components/Breadcrumbs.vue";

export default {
  components: {
    RakoonChat,
    RakoonChatHistory,
    Breadcrumbs
  },
  data() {
    return {
      selectedChat: null,
    };
  },
  methods: {
    setSelectedChat(chat) {
      this.selectedChat = chat;
    },
    chatHistoryLists() {
      this.$refs['rakoonChatHistory'].getChatHistoryLists();
    },
    latestChatHistory(question) {
      this.$refs['rakoonChatHistory'].updateLatestChatHistory(question);
    },
    newChat() {
      this.$refs['rakoonChat'].createNewChat();
    }
  },
};
</script>
<style>
.router-container {
  height: 100% !important;
}
.main-block{
  min-height: 100% !important;
}

.p-0.overflow-hidden.container-fluid,
.p-0.overflow-hidden.container-fluid>div {
  height: 95% !important;
}
</style>
